var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 15,
    height: 15,
    rx: 3,
    fill: "#2BE7A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16104 9.54075L4.71132 8.16101C4.63328 8.0866 4.52725 8.0447 4.41678 8.0447C4.30624 8.0447 4.20028 8.0866 4.12225 8.16101C3.95925 8.31606 3.95925 8.56659 4.12225 8.72164L5.86854 10.3837C6.03153 10.5388 6.29469 10.5388 6.45768 10.3837L10.8778 6.17687C11.0407 6.02182 11.0407 5.77136 10.8778 5.61624C10.7998 5.54183 10.6938 5.5 10.5833 5.5C10.4728 5.5 10.3668 5.54183 10.2887 5.61624L6.16104 9.54075Z",
    fill: "#1C192B",
    stroke: "#1C192B",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/CheckboxChecked.4f7cf7a5e049c892cb4efba2ee417375.svg";
export { ForwardRef as ReactComponent };